import { render, staticRenderFns } from "./ServiceAgreement.vue?vue&type=template&id=359b1554&scoped=true"
import script from "./ServiceAgreement.vue?vue&type=script&lang=js"
export * from "./ServiceAgreement.vue?vue&type=script&lang=js"
import style0 from "./ServiceAgreement.vue?vue&type=style&index=0&id=359b1554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b1554",
  null
  
)

export default component.exports